/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from '@servicetitan/application-data/common-interfaces';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface ICampaignCostApi {
    saveEmailMonthlyCost(cost: number, cancelToken?: CancelToken): AxiosPromise<void>;
    getVariableMonthlyCosts(channel: MarketingChannel, campaignId: number, startingYear: number, yearsCount: number, cancelToken?: CancelToken): AxiosPromise<CampaignCostsModel>;
    saveVariableMonthlyCosts(channel: MarketingChannel, campaignId: number, startingYear: number, yearsCount: number, costs: number[], cancelToken?: CancelToken): AxiosPromise<void>;
}

export const BASE_URL_TOKEN_CampaignCostApi = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class CampaignCostApi implements ICampaignCostApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_CampaignCostApi) @optional() private readonly baseUrl = "") {
    }

    saveEmailMonthlyCost(cost: number, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/app/api/marketing/cost/email-monthly-cost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = cost;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    getVariableMonthlyCosts(channel: MarketingChannel, campaignId: number, startingYear: number, yearsCount: number, cancelToken?: CancelToken): AxiosPromise<CampaignCostsModel> {
        let url_ = "/app/api/marketing/cost/var-monthly-cost?";
        if (channel === undefined || channel === null)
            throw new Error("The parameter 'channel' must be defined and cannot be null.");
        else
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (startingYear === undefined || startingYear === null)
            throw new Error("The parameter 'startingYear' must be defined and cannot be null.");
        else
            url_ += "startingYear=" + encodeURIComponent("" + startingYear) + "&";
        if (yearsCount === undefined || yearsCount === null)
            throw new Error("The parameter 'yearsCount' must be defined and cannot be null.");
        else
            url_ += "yearsCount=" + encodeURIComponent("" + yearsCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<CampaignCostsModel>(options_));
    }

    saveVariableMonthlyCosts(channel: MarketingChannel, campaignId: number, startingYear: number, yearsCount: number, costs: number[], cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/app/api/marketing/cost/var-monthly-cost?";
        if (channel === undefined || channel === null)
            throw new Error("The parameter 'channel' must be defined and cannot be null.");
        else
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (startingYear === undefined || startingYear === null)
            throw new Error("The parameter 'startingYear' must be defined and cannot be null.");
        else
            url_ += "startingYear=" + encodeURIComponent("" + startingYear) + "&";
        if (yearsCount === undefined || yearsCount === null)
            throw new Error("The parameter 'yearsCount' must be defined and cannot be null.");
        else
            url_ += "yearsCount=" + encodeURIComponent("" + yearsCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = costs;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }
}

export interface CampaignCostsModel {
    /** Cost models for each month, sorted in ascending order. */
    costs: CampaignMonthCostModel[];
}

export interface CampaignMonthCostModel {
    year: number;
    month: number;
    dailyCost: number;
    /** For UI only */
    daysInMonth: number;
}

export enum MarketingChannel {
    DirectMail = 0,
    Email = 1,
    Legacy = 2,
    PowerDialer = 3,
    Sms = 4,
    Digital = 5,
    MultiChannel = 6,
}
